import styled from 'styled-components';

import { fromLarge } from 'styleUtils/mediaQueries';
import { gridColumn } from 'styleUtils/grid';

export const RightCol = styled.div`
    ${fromLarge`
        ${gridColumn({ start: 2 })}
    `};
`;
